import { ref } from 'vue'

export default function usePagination(config = {}) {
  const totalPagesCount = ref(0)
  const totalCount = ref(0)
  const currentPage = ref(1)
  const pageSize = ref(config?.pageSize || 10)

  const setPagination = (response) => {
    totalPagesCount.value = parseInt(response.headers['total-pages'], 10)
    totalCount.value = parseInt(response.headers['total-count'], 10)
    currentPage.value = parseInt(response.headers['page-number'], 10)
    pageSize.value = parseInt(response.headers['page-size'], 10)
  }

  const currentPageInfo = () => {
    let firstVisible = pageSize.value * (currentPage.value - 1) + 1
    const lastVisible = Math.min(firstVisible + pageSize.value - 1, totalCount.value)

    if (firstVisible > lastVisible) {
      firstVisible = lastVisible
    }

    return `${firstVisible}-${lastVisible}`
  }

  return {
    totalPagesCount,
    totalCount,
    currentPage,
    pageSize,
    setPagination,
    currentPageInfo
  }
}
